import React from 'react';
import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom';
import './App.css';
import ErrorBoundary from './components/ErrorBoundary';
import PhotoStudioFormEnhanced from './components/PhotoStudioFormEnhanced';
import ProtectedAdminRoute from './components/ProtectedAdminRoute';
import AdminDashboard from './components/AdminDashboard';
import StudioTvDisplay from './components/StudioTVDisplay';

function App() {
  return (
    <ErrorBoundary>
      <Router>
        <div className="App">
          <header className="app-header" style={{
            backgroundColor: '#232f3e',
            color: 'white',
            padding: '1rem 2rem',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center'
          }}>
            <h1 style={{ margin: 0, fontSize: '1.5rem' }}>
              📸 Amazon Photo Studio Appointment
            </h1>
            <div className="header-links">
              <Link 
                to="/admin" 
                className="admin-link"
                style={{
                  backgroundColor: '#ff9900',
                  color: 'white',
                  textDecoration: 'none',
                  padding: '0.5rem 1rem',
                  borderRadius: '4px',
                  fontSize: '0.9rem'
                }}
              >
                🛠️ Admin Dashboard
              </Link>
            </div>
          </header>
          
          <main>
            <Routes>
              <Route path="/" element={
                <div style={{ padding: '2rem', maxWidth: '800px', margin: '0 auto' }}>
                  <PhotoStudioFormEnhanced />
                </div>
              } />
              <Route path="/admin" element={
                <ProtectedAdminRoute>
                  <AdminDashboard />
                </ProtectedAdminRoute>
              } />
              <Route path="/studio-tv-display" element={
                <StudioTvDisplay />
              } />
            </Routes>
          </main>
        </div>
      </Router>
    </ErrorBoundary>
  );
}

export default App;